import React, { FC } from 'react';

import { BracketCellGroup } from '../../../../../utils/groupMatchesByBracketCell';
import { ClassValues } from '../../../TournamentClasses/components/ClassesTag/ClassesTag';
import { BracketCellSettingsAccordion } from './BracketCellSettingsAccordion';

type BracketCellEditorProps = {
  group: BracketCellGroup;
  currentClass: ClassValues | undefined;
  variant?: 'group' | 'elimination';
  showCellLevelTeams?: boolean;
  handleAddTeamForBracketCell?: (bracketCellId: string, fieldName: string) => void;
};

export const BracketCellEditor: FC<BracketCellEditorProps> = ({
  group,
  currentClass,
  variant = 'elimination',
  showCellLevelTeams,
  handleAddTeamForBracketCell,
}) => {
  return (
    <BracketCellSettingsAccordion
      group={group}
      currentClass={currentClass}
      variant={variant}
      showCellLevelTeams={showCellLevelTeams}
      handleAddTeamForBracketCell={handleAddTeamForBracketCell}
    />
  );
};
